import React from 'react';
import clsx from 'clsx';
import { Search } from 'lucide-react';

/**
 * Ground of the field, which depends on what is behind it: inside a white card
 * it has to be darker, and on the page background it has to be lighter, or it
 * disappears into it — in dark mode `#111` is all but the page itself.
 */
const VARIANTS = {
  card: 'bg-ninja-gray/50 dark:bg-[#111]',
  bare: 'bg-white dark:bg-[#1a1a1a]',
};

/**
 * Search box of a listing, with the magnifier inside. Controlled, and it hands
 * back the text rather than the event.
 *
 * No debounce of its own: a listing filtered in the browser can react to every
 * key, and one that asks the server debounces where it dispatches.
 *
 * @param {object} props
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.placeholder='Buscar...'] - Also its accessible name.
 * @param {'card'|'bare'} [props.variant='card'] - Where the box is standing.
 * @param {string} [props.testId='search-input']
 * @param {string} [props.className]
 */
export const SearchInput = ({
  value,
  onChange,
  placeholder = 'Buscar...',
  variant = 'card',
  testId = 'search-input',
  className = '',
}) => (
  <div className={clsx('relative w-full sm:max-w-md', className)}>
    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <Search size={18} className="text-text-muted" />
    </div>
    <input
      type="search"
      data-testid={testId}
      aria-label={placeholder}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={clsx(
        'w-full pl-10 pr-4 py-2 border border-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-ninja-green focus:border-transparent transition-all dark:text-white',
        VARIANTS[variant] ?? VARIANTS.card
      )}
    />
  </div>
);
